import styled from 'styled-components';

export const ConfirmationContainer = styled.div`
  width: 100%;

  p {
    text-align: left;
    font-size: 16px;
  }
`;
